// Computes "bundle savings" vs buying each component separately.
// Only returns a number when every component resolves to a real catalog
// book with its own price AND the bundle price is actually lower — never
// a fabricated/marketing-only figure.
export function getBundleSavings(book, catalog) {
  if (!book?.bundle_components?.length || !catalog?.length) return null;
  if (!book.bundle_components.every((c) => c.book_id)) return null;
  let sum = 0;
  for (const c of book.bundle_components) {
    const comp = catalog.find((b) => b.id === c.book_id);
    if (!comp) return null;
    sum += comp.price;
  }
  const diff = sum - book.price;
  return diff > 0 ? diff : null;
}
